import { translate } from '../../util/translator';

export default function () {
  let agreementCheckbox = document.querySelector('.garage-contact [name="external.accepted"]')
  let tradeOfferCheckbox = document.querySelector('.garage-contact [name="external.tradeOffer"]')
  let email = document.querySelector('.garage-contact [name="external.email"]')
  let firstName = document.querySelector('.garage-contact [name="external.first"]')
  let lastName = document.querySelector('.garage-contact [name="external.last"]')
  let phone = document.querySelector('.garage-contact [name="external.phone"]')
  let content = document.querySelector('.garage-contact textarea')
  let api_uri = document.head.querySelector('meta[name=api_uri]').getAttribute('content')
  let garageId = parseInt(document.querySelector('.garage-contact').getAttribute('data-garageId'))

  let inputsWithBackendValidation = [ firstName, lastName, email, content, agreementCheckbox ]
  let inputsWithFrontendValidation = [ phone ]

  let sendFormBtn = document.querySelector('.contact-form__send')

  function alertContents (httpRequest) {
    if (httpRequest.currentTarget.readyState === XMLHttpRequest.DONE) {
      if (httpRequest.currentTarget.status === 200 || httpRequest.currentTarget.status === 201) {
        cleanErrors([ ...inputsWithBackendValidation, ...inputsWithFrontendValidation ])
        document.querySelector('.contact-form-success-info').style.display = 'flex'
      } else {
        let response = JSON.parse(httpRequest.currentTarget.responseText)

        let errors = Object.keys(response.errors)

        for(let error of errors){
          errors[errors.indexOf(error)] = [error, [ translate('validation-' + error, response.errors[error][0]) ]]
        }

        cleanErrors([ ...inputsWithBackendValidation, ...inputsWithFrontendValidation ])
        setErrorsFromBackend(errors, inputsWithBackendValidation)
      }
    }
  }

  sendFormBtn.addEventListener('click', () => {
    let messageBody = {
      type: 'external',
      external: {
        accepted: agreementCheckbox.checked,
        email: email.value,
        first: firstName.value,
        last: lastName.value,
        garage: garageId
      },
      content: content.value
    }

    cleanErrors([ ...inputsWithBackendValidation, ...inputsWithFrontendValidation ])

    let frontendErrorsOccured = setErrorsFromFrontend(inputsWithFrontendValidation)

    if (!frontendErrorsOccured) {

      let httpRequest = new XMLHttpRequest()
      httpRequest.onreadystatechange = (httpRequest) => alertContents(httpRequest)
      httpRequest.open('POST', api_uri + '/api/inbox/request')
      httpRequest.setRequestHeader('Content-Type', 'application/json;charset=UTF-8')
      httpRequest.send(JSON.stringify(messageBody))


    }

  })

  let setErrorsFromFrontend = (inputsArr) => {

    let errorsOccured = false

    inputsArr.forEach(input => {
      if (input.value === '') {
        errorsOccured = true
        if (input.tagName === 'SELECT') {
          input.closest('.contact-form__select-wrapper').classList.add('contact-form__input--error')
          let errMessage = document.createElement('p')
          errMessage.classList.add('error-message')
          errMessage.innerHTML = translate('validation-reqired','Pole jest wymagane')
          input.closest('.contact-form-input-container').append(errMessage)
        } else {
          input.classList.add('contact-form__input--error')
          let errMessage = document.createElement('p')
          errMessage.classList.add('error-message')
          errMessage.innerHTML = translate('validation-reqired','Pole jest wymagane')
          input.closest('.contact-form-input-container').append(errMessage)
        }
      }
    })

    return errorsOccured
  }

  let setErrorsFromBackend = (errorsArr, inputsArr) => {
    errorsArr.forEach(e => {
      inputsArr.find((input) => {
        if (input.name == e[ 0 ]) {
          input.classList.add('contact-form__input--error')
          let errMessage = document.createElement('p')
          errMessage.classList.add('error-message')
          errMessage.innerHTML = e[ 1 ]
          input.closest('.contact-form-input-container').append(errMessage)
        }
      })
    })
  }

  let cleanErrors = (inputsArr) => {
    // remove error input styles
    let errInputs = document.querySelectorAll('.contact-form__input--error')
    if (errInputs) {
      errInputs.forEach(e => {
        e.classList.remove('contact-form__input--error')
      })
    }

    // remove error messages under inputs
    let errMessages = document.querySelectorAll('.error-message')
    if (errMessages) {
      errMessages.forEach(e => {
        e.parentNode.removeChild(e)
      })
    }
  }
}
